import { useCallback } from 'react';
import { useAuth } from '../../../shared/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export function useLogout() {
  const { logout: authLogout } = useAuth();
  const navigate = useNavigate();

  const logout = useCallback(async () => {
    await authLogout();
    navigate('/login');
  }, [authLogout, navigate]);

  return { logout };
}
